// src/DayOfWeek.ts
var DAYS_OF_WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];
var toDayOfWeek = (date) => DAYS_OF_WEEK[date.getDay()];

export {
  DAYS_OF_WEEK,
  toDayOfWeek
};
